import { shortAssetRequestErrorSummary, type AssetRequestError } from '../api/getAssetById';
import styles from './AssetRequestErrorPanel.module.css';

export type AssetRequestErrorPanelProps = {
  error: AssetRequestError;
};

/** User-facing API error — plain summary only, no JSON or HTTP dumps. */
export function AssetRequestErrorPanel({ error }: AssetRequestErrorPanelProps) {
  return (
    <div className={styles.errorPanel} role="alert">
      <p className={styles.errorSummary}>{shortAssetRequestErrorSummary(error)}</p>
    </div>
  );
}
